// public/js/modules/filters/asset-type-filter.js
export const assetTypeFilter = {
    id: 'assetType',
    getDefaultState: () => ({ enabledTypes: new Set(['engine-stand', 'apu', 'other']) }),
  
    renderUI(state, manager) {
      const types = ['engine-stand', 'apu', 'other'];
      return `
        <div class="mb-4">
          <h6 class="fw-bold mb-2">Asset Typ</h6>
          ${types.map(t => `
            <div class="form-check">
              <input class="form-check-input" type="checkbox" 
                     id="type-${t}" ${state.enabledTypes.has(t) ? 'checked' : ''}>
              <label class="form-check-label" for="type-${t}">
                ${t === 'engine-stand' ? 'Engine Stand' : t === 'apu' ? 'APU' : 'Other'}
              </label>
            </div>
          `).join('')}
        </div>`;
    },
  
    apply(assets, state) {
      if (!state.enabledTypes || state.enabledTypes.size === 0) return assets;
      return assets.filter(a => state.enabledTypes.has(a.type || 'other'));
    },
  
    attachListeners(container, manager) {
      container.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.addEventListener('change', () => {
          const type = cb.id.replace('type-', '');
          const enabled = new Set(manager.getState().assetType.enabledTypes);
          if (cb.checked) enabled.add(type);
          else enabled.delete(type);
          manager.updateFilter('assetType', { enabledTypes: enabled });
        });
      });
    }
  };